// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1L12E","content":"LoadingAlert_content__33e0Y"};